import debounce from 'lodash/debounce';
import once from 'lodash/once';
import {isIE} from 'utils';

$(window).on('load', () => {
  const $container = $('#container-404');

  if (!$container || !$container.length) {
    return;
  }

  require.ensure(['physicsjs'], () => {
    const Physics = require('physicsjs');

    const $message1 = $('#message-1');
    const $message2 = $('#message-2');
    const $overlayTools = $('#overlay-tools');

    let triggerMessageCollapse = false;
    let triggerMessageGravity = false;

    const definitions = {
      contents: [
        {
          el: $('#char-0')[0],
          x: 120,
          y: 0,
          width: 57,
          height: 108,
          mass: 1,
          restitution: 0.5,
        },
        {
          el: $('#char-4-1')[0],
          x: 193,
          y: 0,
          width: 63,
          height: 108,
          mass: 1,
          restitution: 0.5,
        },
        {
          el: $('#char-4-2')[0],
          x: 0,
          y: 0,
          width: 63,
          height: 108,
          angle: 270,
          mass: 1,
          restitution: 0.5,
        },
        {
          el: $('#bottle')[0],
          x: 262,
          y: 0,
          width: 64,
          height: 221,
          mass: 1,
          restitution: 0.5,
        },
        {
          el: $('#cards')[0],
          x: 722,
          y: 0,
          width: 155,
          height: 142,
          mass: 10,
          restitution: 0.1,
        },
        {
          el: $('#paint-1')[0],
          x: 600,
          y: 0,
          width: 111,
          height: 134,
          mass: 5,
          restitution: 0.2,
        },
        {
          el: $('#paint-2')[0],
          x: 600,
          y: -135,
          width: 92,
          height: 90,
          mass: 5,
          restitution: 0.2,
        },
        {
          el: $('#sealant')[0],
          x: 331,
          y: 0,
          width: 55,
          height: 328,
          mass: 1,
          restitution: 0.5,
        },
        {
          el: $('#spray')[0],
          x: 539,
          y: 0,
          width: 51,
          height: 158,
          mass: 1,
          restitution: 0.5,
        },
        {
          el: $('#tape')[0],
          x: 397,
          y: 0,
          width: 117,
          height: 30,
          mass: 1,
          restitution: 0.5,
        },
      ],
      shelf: {
        el: $('#shelf')[0],
        x: 0,
        y: 280,
        width: 929,
        height: 35,
        angle: 0,
      },
      message: {
        el: $message1[0],
        x: 400,
        y: 800,
        width: 864,
        height: 60,
        angle: 0,
      },
      leftWall: {
        y: 0,
        width: 100,
        angle: 0,
      },
    };

    const instances = {
      contents: [],
      shelf: null,
    };

    // Trigger physics sandbox on desktop, use basic animation on tablet/mobile.
    if (!isIE() && $container.length && $container.outerWidth(true) >= 1200) {
      $container.addClass('has-physics');

      const options = {
        sleepDisabled: true,
      };

      Physics(options, [initialise]);
    } else {
      $container.addClass('no-physics');

      setTimeout(showContainer, 100);
      setTimeout(showMessage1, 1000);
      setTimeout(hideMessage1, 3000);
      setTimeout(showMessage2, 3000);
      setTimeout(hideMessage2, 5000);
      setTimeout(showToolsOverlay, 5000);
    }

    /** Initialise 404 page. */
    function initialise(world) {
      // Set renderer based on env.
      const rendererName = 'dom';

      // Add renderer.
      const renderer = Physics.renderer(rendererName, {
        el: $container[0],
      });

      world.add(renderer);

      // Add shelf instance.
      instances.shelf = Physics.body('rectangle', {
        treatment: 'kinematic',
        x: renderer.width - definitions.shelf.x,
        y: definitions.shelf.y,
        width: definitions.shelf.width,
        height: definitions.shelf.height,
        cof: 1,
        mass: 50,
        styles: {
          src: definitions.shelf.texture,
        },
        offset: Physics.vector(-(definitions.shelf.width / 2) + 20, 0),
      });

      instances.shelf.view = definitions.shelf.el;

      world.add(instances.shelf);

      // Add message instance.
      if (renderer.width >= 1600) {
        instances.message = Physics.body('rectangle', {
          treatment: 'kinematic',
          x: renderer.width * 0.25,
          y: definitions.message.y,
          width: definitions.message.width,
          height: definitions.message.height,
          cof: 0.2,
          mass: 50,
          styles: definitions.message.styles,
          offset: Physics.vector(definitions.message.width / 2 - 20, 0),
        });

        instances.message.view = definitions.message.el;

        world.add(instances.message);
      }

      // Add left wall instance.
      let leftWallX = 0;

      if (renderer.width >= 1700) {
        leftWallX = renderer.width / 3.2;
      } else if (renderer.width >= 1400) {
        leftWallX = renderer.width / 5;
      }

      if (leftWallX > 0) {
        instances.leftWall = Physics.body('rectangle', {
          treatment: 'kinematic',
          hidden: true,
          x: leftWallX,
          y: renderer.height / 2,
          width: definitions.leftWall.width,
          height: renderer.height,
          cof: 1,
          mass: 50,
          styles: definitions.leftWall.styles,
        });

        instances.leftWall.view = definitions.leftWall.el;

        world.add(instances.leftWall);
      }

      // Add shelf contents.
      definitions.contents.forEach(item => {
        let x = renderer.width - item.x;
        let y = definitions.shelf.y - definitions.shelf.height / 2 + item.y;
        const angle = item.angle || 0;

        switch (angle) {
          default:
          case 0:
          case 180:
            x -= item.width / 2;
            y -= item.height / 2;
            break;

          case 90:
          case 270:
            x -= item.height / 2;
            y -= item.width / 2;
            break;
        }

        const instance = Physics.body('rectangle', {
          treatment: 'kinematic', // start kinematic to reduce wobble on load
          x,
          y,
          width: item.width,
          height: item.height,
          mass: item.mass,
          restitution: item.restitution,
          styles: {
            src: item.texture,
          },
        });

        instance.view = item.el;

        world.add(instance);

        instance.state.angular.pos += toRadians(angle);

        instances.contents.push(instance);
      });

      // Add physics behaviors.
      world.add([
        createGravity(instances.contents),
        Physics.behavior('body-impulse-response'),
        Physics.behavior('body-collision-detection'),
        Physics.behavior('sweep-prune'),
      ]);

      // Subscribe to ticker to advance the simulation
      Physics.util.ticker.on(time => {
        world.step(time);
      });

      // Start the ticker
      Physics.util.ticker.start();

      /** Set contents and friction to allow collapse. */
      const initShelfCollapse = once(() => {
        instances.contents.forEach(item => {
          // eslint-disable-next-line no-param-reassign
          item.treatment = 'dynamic';
        });

        instances.shelf.cof = 0.2;
      });

      /** Set angular acceleration to collapse shelf, clear after target angle is reached. */
      const stepShelfCollapse = function stepShelfCollapse() {
        // eslint-disable-next-line no-underscore-dangle
        if (world._time > 1000 && instances.shelf.state.angular.pos > toRadians(-16)) {
          initShelfCollapse();
          instances.shelf.state.angular.acc = toRadians(-0.0004);
        } else {
          instances.shelf.state.angular.acc = 0;
          instances.shelf.state.angular.vel = 0;
        }
      };

      /** Set angular acceleration to collapse message, clear after target angle is reached. */
      const stepMessageCollapse = function stepMessageCollapse() {
        // eslint-disable-next-line no-underscore-dangle
        if (triggerMessageCollapse && instances.message.state.angular.pos < toRadians(16)) {
          instances.message.state.angular.acc = toRadians(0.0004);
        } else {
          instances.message.state.angular.acc = 0;
          instances.message.state.angular.vel = 0;
        }
      };

      /** Add gravity to message. */
      const initMessageGravity = once(() => {
        world.add(createGravity([instances.message]));
        instances.message.treatment = 'dynamic';
        setTimeout(() => {
          instances.message.state.angular.acc = -toRadians(0.01);
        }, 100);
        setTimeout(showMessage2, 2000);
        setTimeout(showToolsOverlay, 4000);
        setTimeout(() => {
          world.pause();
        }, 20000);
      });

      // Handle first physics step.
      world.one('step', () => {
        setTimeout(showContainer, 100);

        if (!instances.message) {
          setTimeout(showMessage1, 1000);
          setTimeout(hideMessage1, 3000);
          setTimeout(showMessage2, 3000);
          setTimeout(hideMessage2, 5000);
          setTimeout(showToolsOverlay, 5000);
          setTimeout(() => {
            world.pause();
          }, 20000);
        }
      });

      // Handle physics step.
      world.on('step', () => {
        world.render();

        stepShelfCollapse();

        if (instances.message) {
          stepMessageCollapse();

          if (triggerMessageGravity) {
            initMessageGravity();
          }
        }
      });

      // Handle physics collisions.
      world.on('collisions:detected', data => {
        data.collisions.forEach(collision => {
          const bodyA = collision.bodyA;
          const bodyB = collision.bodyB;
          const collidedPreviously = collision.collidedPreviously;

          if (collidedPreviously) {
            return;
          }

          if (!instances.message) {
            return;
          }

          if (bodyA.view !== instances.message.view && bodyB.view !== instances.message.view) {
            return;
          }

          triggerMessageCollapse = true;
          setTimeout(() => {
            triggerMessageGravity = true;
          }, 2000);
        });
      });

      // Reposition static and kinematic bodies on resize.
      $(window).on('resize', debounce(onResize, 50));

      /** Create a gravity behavior and apply to bodies. */
      function createGravity(bodies) {
        return Physics.behavior('constant-acceleration', {
          acc: {
            x: 0,
            y: 0.0012,
          },
        }).applyTo(bodies);
      }

      /** Handle window resize event. */
      function onResize() {
        // Destroy world if container is too small.
        if (renderer.width < 1200) {
          world.destroy();
          return;
        }

        // Refresh position of static bodies, cannot deal with dynamic ones.
        let x = 0;
        let y = 0;

        if (instances.shelf && instances.shelf.treatment !== 'dynamic') {
          x = renderer.width - definitions.shelf.x;
          instances.shelf.state.old.pos.x = instances.shelf.state.pos.x = x;
        }

        if (instances.message && instances.message.treatment !== 'dynamic') {
          x = renderer.width - definitions.message.x - definitions.message.width;
          instances.message.state.old.pos.x = instances.message.state.pos.x = x;
        }

        if (instances.leftWall && instances.leftWall.treatment !== 'dynamic') {
          y = renderer.height / 2;
          instances.leftWall.state.old.pos.y = instances.leftWall.state.pos.y = y;
        }
      }
    }

    /** Show the container. */
    function showContainer() {
      $container.addClass('animate-in');
    }

    /** Show the first message. */
    function showMessage1() {
      $message1.addClass('animate-in');
    }

    /** Show the first message. */
    function hideMessage1() {
      $message1.removeClass('animate-in');
    }

    /** Show the second message. */
    function showMessage2() {
      $message2.addClass('animate-in');
    }

    /** Show the second message. */
    function hideMessage2() {
      $message2.removeClass('animate-in');
    }

    /** Show the tools overlay. */
    function showToolsOverlay() {
      $overlayTools.addClass('animate-in');
    }

    /** Convert degrees to radians. */
    function toRadians(degrees) {
      if (!degrees) {
        return 0;
      }
      return (degrees * Math.PI) / 180;
    }
  });
});
